import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Gauge = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      d="M9.5 9.5C9.5 10.3284 8.82843 11 8 11C7.17157 11 6.5 10.3284 6.5 9.5C6.5 8.67157 7.17157 8 8 8C8.13437 8 8.26461 8.01767 8.38853 8.05081L9.96967 6.46967L11.0303 7.53033L9.44919 9.11147C9.48233 9.23539 9.5 9.36563 9.5 9.5Z"
      fill="currentColor"
    />
    <path
      clipRule="evenodd"
      d="M15 9.5C15 10.9872 14.5362 12.3662 13.7453 13.5H2.25469C1.46381 12.3662 1 10.9872 1 9.5C1 5.63401 4.13401 2.5 8 2.5C11.866 2.5 15 5.63401 15 9.5ZM3.6167 6.17736C3.05872 6.91232 2.68135 7.79191 2.55071 8.75H4V10.25H2.55055C2.63531 10.8732 2.82427 11.4622 3.09933 12H12.9007C13.1757 11.4622 13.3647 10.8732 13.4494 10.25H12V8.75H13.4493C13.3187 7.79191 12.9413 6.91232 12.3833 6.17736L11.5303 7.03033L10.4697 5.96967L11.3226 5.1167C10.5877 4.55872 9.70809 4.18135 8.75 4.05071V5.5H7.25V4.05071C6.29191 4.18135 5.41232 4.55872 4.67736 5.1167L5.53033 5.96967L4.46967 7.03033L3.6167 6.17736Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default Gauge;
